import { render } from "./index.vue?vue&type=template&id=32532bb3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32532bb3&lang=scss"
script.render = render

export default script